import { IModulos, IPermiso } from 'modelos/src';

/**
 * Mapea el tipo de evento técnico a los módulos (especialidades) que habilitan a
 * un técnico a atenderlo. El técnico califica si tiene ALGUNO de esos módulos.
 * - Tracker → lo atiende un técnico de Vehículos o de Colectivos.
 * - Gateway → lo atiende un técnico de Luminarias.
 * Sirve para filtrar, al asignar un ST, solo los técnicos de esa especialidad.
 */
const MODULOS_POR_TIPO_EVENTO: Record<string, (keyof IModulos)[]> = {
  'Evento Técnico Alarma': ['moduloAlarmasDomiciliarias'],
  'Evento Técnico Vehículo': ['moduloVehiculos'],
  'Evento Técnico Tracker': ['moduloVehiculos', 'moduloColectivos'],
  'Evento Técnico Luminaria': ['moduloLuminarias'],
  'Evento Técnico Sirena': ['moduloSirenas'],
  'Evento Técnico Gateway': ['moduloLuminarias'],
  'Evento Técnico Colectivo': ['moduloColectivos'],
};

export function modulosParaTipoEvento(
  tipoEvento?: string | null,
): (keyof IModulos)[] {
  return (tipoEvento && MODULOS_POR_TIPO_EVENTO[tipoEvento]) || [];
}

/** Etiquetas de especialidad por módulo, para mostrar de qué es técnico. */
const ESPECIALIDAD_LABELS: { modulo: keyof IModulos; label: string }[] = [
  { modulo: 'moduloAlarmasDomiciliarias', label: 'Alarmas' },
  { modulo: 'moduloVehiculos', label: 'Vehículos' },
  { modulo: 'moduloColectivos', label: 'Colectivos' },
  { modulo: 'moduloLuminarias', label: 'Luminarias' },
  { modulo: 'moduloSirenas', label: 'Sirenas' },
];

/** Especialidades (labels) de un técnico según los módulos de su permiso. */
export function especialidadesDeTecnico(
  permiso: IPermiso | undefined,
): string[] {
  const modulos = permiso?.modulos as Record<string, boolean> | undefined;
  return ESPECIALIDAD_LABELS.filter((e) => modulos?.[e.modulo]).map(
    (e) => e.label,
  );
}

/**
 * true si el técnico (por su permiso) puede atender ese tipo de ST. Si el tipo
 * no tiene módulos mapeados, no se filtra (devuelve true).
 */
export function tecnicoAtiendeTipo(
  permiso: IPermiso | undefined,
  tipoEvento?: string | null,
): boolean {
  const requeridos = modulosParaTipoEvento(tipoEvento);
  if (!requeridos.length) return true;
  const modulos = permiso?.modulos as Record<string, boolean> | undefined;
  return requeridos.some((m) => modulos?.[m] === true);
}
